import { Address } from "./../companies/address";
import { GenderType } from "./gender-type";

export class Gender {
  private value: number;
  private view: string;
  private options = [GenderType.Male, GenderType.Female, GenderType.Unknow];

  setGender(value: number): void {
    this.value = value;
    this.view = this.options[this.value];
  }

  getValue(): number {
    return this.value;
  }

  getView(): string {
    return this.view;
  }

  getOptions(): string[] {
    return this.options;
  }
}

export class MaritalStatus {
  private value: number;
  private view: string;
  private options = ["Casado", "Solteiro", "Divorciado", "Viúvo"];

  setMaritalStatus(value: number): void {
    this.value = value;
    this.view = this.options[this.value];
  }

  getValue(): number {
    return this.value;
  }

  getView(): string {
    return this.view;
  }

  getOptions(): string[] {
    return this.options;
  }
}

export abstract class Person {
  private name: string;
  private socialNumber: string;
  private birthDate: string;
  private nationality: string;
  private address: Address;
  private email: string;
  private gender: Gender;
  private maritalStatus: MaritalStatus;
  private telephone: string;
  private mobile: string;

  setName(value: string): void {
    this.name = value;
  }

  getName(): string {
    return this.name;
  }

  setSocialNumber(value: string): void {
    this.socialNumber = value;
  }

  getSocialNumber(): string {
    return this.socialNumber;
  }

  setBirthDate(value: string): void {
    this.birthDate = value;
  }

  getBirthDate(): string {
    return this.birthDate;
  }

  setNationality(value: string): void {
    this.nationality = value;
  }

  getNationality(): string {
    return this.nationality;
  }

  setAddress(value: Address): void {
    this.address = value;
  }

  getAddress(): Address {
    return this.address;
  }

  setEmail(value: string): void {
    this.email = value;
  }

  getEmail(): string {
    return this.email;
  }

  setGender(value: Gender): void {
    this.gender = value;
  }

  getGender(): Gender {
    return this.gender;
  }

  setMaritalStatus(value: MaritalStatus): void {
    this.maritalStatus = value;
  }

  getMaritalStatus(): MaritalStatus {
    return this.maritalStatus;
  }

  setTelephone(value: string): void {
    this.telephone = value;
  }

  getTelephone(): string {
    return this.telephone;
  }

  setMobile(value: string): void {
    this.mobile = value;
  }

  getMobile(): string {
    return this.mobile;
  }

 


}
